import {
  HouseLine,
  ChartLine,
  FileText,
  Funnel,
  Book,
  UserCircle,
  CurrencyEth,
  Coins,
  Users,
  Handshake,
  FileCode,
  Folders,
  GridNine,
  Compass,
  PenNib,
} from "@phosphor-icons/react"
import { type ElementType, type SVGProps } from "react"

export enum SIDEBAR_ICON {
  Home = "home",
  Discover = "compass",
  Markets = "markets",
  Metrics = "metrics",
  Projects = "projects",
  Trending = "trending",
  Financial = "financial",
  Screener = "screener",
  ApiDocs = "apiDocs",
  Docs = "docs",
  InsiderTransactions = "insiderTransactions",
  Stablecoins = "stablecoins",
  CohortAnalysis = "cohort",
  Fundraises = "fundraises",
  ProjectContracts = "projectContracts",
  Studio = "studio",
}

interface Props extends Omit<SVGProps<SVGElement>, "type"> {
  type: SIDEBAR_ICON
}

const FinancialIcon = (props: any) =>
  props["data-active"] ? (
    <FileText {...props} weight="fill" />
  ) : (
    <FileText {...props} />
  )

const StablecoinsIcon = (props: any) =>
  props["data-active"] ? (
    <Coins {...props} weight="fill" />
  ) : (
    <Coins {...props} />
  )

export const getSidebarIcon = (type: Props["type"]): ElementType | null => {
  switch (type) {
    case "home":
      return HouseLine
    case "compass":
      return Compass
    case "markets":
      return Folders
    case "metrics":
      return ChartLine
    case "projects":
      return CurrencyEth
    case "trending":
      return GridNine
    case "financial":
      return FinancialIcon
    case "screener":
      return Funnel
    case "apiDocs":
      return Book
    case "docs":
      return Book
    case "insiderTransactions":
      return UserCircle
    case "stablecoins":
      return StablecoinsIcon
    case "cohort":
      return Users
    case "fundraises":
      return Handshake
    case "projectContracts":
      return FileCode
    case "studio":
      return PenNib
    default:
      return null
  }
}
